import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import AppLayout from "@/components/AppLayout";
import { ShieldCheck, Users } from "lucide-react";
import { Link } from "react-router-dom";

export default function FamilyPage() {
  const { t } = useI18n();
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    api.get("/emergency-contacts").then((r) => setContacts(r.data)).catch(() => {});
  }, []);

  return (
    <AppLayout>
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-2">{t.nav.family}</div>
        <h1 className="font-serif text-5xl text-ag-ink mb-2">{t.family.title}</h1>
        <p className="text-slate-600 max-w-xl">{t.family.subtitle}</p>
      </header>

      {contacts.length === 0 ? (
        <div className="ag-card p-12 text-center">
          <div className="h-14 w-14 rounded-2xl bg-slate-100 mx-auto flex items-center justify-center mb-4">
            <Users className="h-6 w-6 text-slate-500" strokeWidth={1.4} />
          </div>
          <p className="text-slate-600 max-w-md mx-auto">Fügen Sie unter <Link to="/notfall" className="text-ag-ink underline">Notfall</Link> Personen Ihres Vertrauens hinzu.</p>
        </div>
      ) : (
        <div className="ag-card overflow-hidden">
          <ul className="divide-y divide-slate-100">
            {contacts.map((c) => (
              <li key={c.id} className="flex items-center gap-4 p-5">
                <div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center text-ag-ink font-serif text-lg">
                  {c.name?.charAt(0)?.toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-serif text-lg text-ag-ink">{c.name}</div>
                  <div className="text-xs text-slate-500">{c.relationship} {c.phone ? `· ${c.phone}` : ""}</div>
                </div>
                <span className={`ag-badge ${c.access_allowed ? "ag-badge-green" : "ag-badge-slate"}`}>
                  <ShieldCheck className="h-3 w-3" />
                  {c.access_allowed ? "Vertrauensperson" : "Information"}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </AppLayout>
  );
}
